import { environment } from "../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { endpointsURL } from "src/app/constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class CompareVersionsPeticionesService {
  env = environment.env;
  compareVersionsURL = endpointsURL.compareVersionsURL;

  constructor(private httpClient: HttpClient) {}

  public getRelease(
    idPeticion: string,
    release: number,
    isReform: boolean,
    isOtherCertificate: boolean
  ): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.compareVersionsURL}?_identificador=${idPeticion}&_version=${release}&_isReform=${isReform}&_isOtherCertificate=${isOtherCertificate}`
    );
  }
}
